module.exports = __webpack_public_path__ + "img/dagou.f8d903b8.png";